import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-deal-unchanged-report',
  templateUrl: './deal-unchanged-report.component.html',
  styleUrls: ['./deal-unchanged-report.component.css']
})
export class DealUnchangedReportComponent implements OnInit {
  dateUtil = new DateUtils;
  dateRange = {startDate: null, endDate: null}
  showTable = false;
  selectedIds = null;
  selectedType = null;
  dateType = '90';
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title:  "Sales Person", key:  "source" },
      { title:  "Deal Name", key:  "name" },
      { title:  "Stage", key:  "currStage" },
      { title:  "Stage Duration", key:  "lastStageChange"},
    ],
    rows: [],
    options: {
      bulkActions: [],
      singleActions: [],
      noOfRowsToDisplay: 3
    }
  }
  constructor(
    private dealSrv: DealsService,
    private reportSetSrv: ReportSettingsService,
    private performRepSrv: PerformanceReportService) { 
      this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
      this.performRepSrv.selected_users.subscribe(res => {
        if(res && res.type) {        
          const { ids, type } = res;
          this.selectedIds = ids;
          this.selectedType = type;
        }
        this.getData();
      })
  }

  ngOnInit() {}
  dateChange({dateRange, dateType}) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.getData();
  }
  getData() {
    let filter: any = {dateFilter: this.dateRange, status: 'OPEN'}
    if(this.selectedType === 'salesperson') {
      filter = {...filter, salesPerson: {ids: this.selectedIds}}
    }
    this.showTable = false;
    this.reportSetSrv.getReportConfig().subscribe((repConfig) => {
      const configVal = repConfig ? repConfig.dealUnchangedDays : 2;
      this.getDealsActs(filter, configVal);
    })
  }
  getDealsActs(filter, configVal) {
    return this.dealSrv.fetchDealsLastActivity(this.selectedIds, filter).pipe(map(deals => {
      return deals.filter(deal => (deal.lastStageChange >= 1 && deal.lastActivityDuration <= configVal))
    })).subscribe(res => {
      this.dataTable.rows = res;
      this.dataTable.dataChangedObs.next(true);
      this.showTable = true
    });
  }

}
